// extracted by mini-css-extract-plugin
module.exports = {"loaderOuter":"styles_loaderOuter__dh630","loaderInner":"styles_loaderInner__eWEVN","load":"styles_load__1XyyR"};